import React, {Component} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {Col, Container, Row} from "react-bootstrap";
import {removeUserSession} from "../Utils/Security";
import CustomAlert from "./CustomAlert";
import "./PolicySupportTool.css";
import BackCastingResult from "./BackCastingResult";

class BackCasting extends Component {

    componentDidMount() {
        this.retrieveImpacts();
        this.retrieveParams();
    }

    state = {
        targetYear: '2021',
        baseScenario: '',
        gdpPerCapita: '',
        annualGdp: '',
        inflation: '',
        cityPopulation: '',
        urbanShuttleFleetSize: '',
        freightShuttleFleetSize: '',
        averageLoadPerFreightVehicle: '',
        averageAnnualFreightTransportDemand: '',
        annualCityPopulation: '',
        humanDrivenVehicles: '',
        firstGen: '',
        secondGen: '',
        fuelCost: '',
        electricityCost: '',
        fuelConsumption: '',
        electricityConsumption: '',
        travelTime: '',
        vehicleOperationCost: '',
        freightTransportCost: '',
        accessToTravel: '',
        travelSplitPublicTransport: '',
        travelSplitActiveTravel: '',
        shareMobilityRate: '',
        vehicleUtilisationRate: '',
        vehicleOccupancy: '',
        amountOfTravel: '',
        congestion: '',
        parkingSpace: '',
        energyEfficiency: '',
        nox: '',
        co2: '',
        pm10: '',
        publicHealth: '',
        inequalityInTransport: '',
        commutingDistances: '',
        vruCrashRates: '',
        roadSafetyMotorized: '',
        roadSafetyTotalEffect: '',
        vruAccidentShare: '',
        vruReferenceSpeed: '',
        hasError: false,
        errorMessage: null,
        formSubmitted: false,
        submittedSuccessfully: false,
        results: '',
        validated: false,
        impacts: [],
        params: [],
        targetImpact1: null,
        targetImpact1Value: null,
        targetImpact2: null,
        targetImpact2Value: null,
        showTargetImpact2: false,
        targetImpact3: null,
        targetImpact3Value: null,
        showTargetImpact3: false,
        targetImpact4: null,
        targetImpact4Value: null,
        showTargetImpact4: false,
        targetImpact5: null,
        targetImpact5Value: null,
        showTargetImpact5: false
    }

    retrieveImpacts = () => {
        axios.get("/api/pst/impacts", {}).then(resp => {
            this.setState({impacts: resp.data});
            this.state.impacts.forEach((impact) => {
                this.updateImpactValue(impact, impact.defaultValue);
            });
        });
    }

    retrieveParams = () => {
        axios.get("/api/pst/params", {}).then(resp => {
            this.setState({params: resp.data});
            this.state.params.forEach((param) => {
                this.updateParamValue(param, param.defaultValue);
            });
        });
    }

    onSelectTargetYear(event) {
        let targetYear = event.target.value;
        this.setState({targetYear: targetYear});
    }

    onSubmit = (event) => {
        let self = this;
        this.setState({formSubmitted: true});
        this.setState({hasError: false});
        this.setState({submittedSuccessfully: false});
        event.preventDefault();

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            this.setState({validated: true});
            return;
        }

        let targetImpacts = {};
        targetImpacts[this.state.targetImpact1] = this.state.targetImpact1Value;
        if (this.state.targetImpact2) {
            targetImpacts[this.state.targetImpact2] = this.state.targetImpact2Value;
        }
        if (this.state.targetImpact3) {
            targetImpacts[this.state.targetImpact3] = this.state.targetImpact3Value;
        }
        if (this.state.targetImpact4) {
            targetImpacts[this.state.targetImpact4] = this.state.targetImpact4Value;
        }
        if (this.state.targetImpact5) {
            targetImpacts[this.state.targetImpact5] = this.state.targetImpact5Value;
        }

        axios.post("/api/back_casting", {
            targetYear: this.state.targetYear,
            targetImpacts: targetImpacts,
            baseScenario: this.state.baseScenario,
            supportTool: {
                gdpPerCapita: this.state.gdpPerCapita,
                annualGdp: this.state.annualGdp,
                inflation: this.state.inflation,
                cityPopulation: this.state.cityPopulation,
                urbanShuttleFleetSize: this.state.urbanShuttleFleetSize,
                freightShuttleFleetSize: this.state.freightShuttleFleetSize,
                averageLoadPerFreightVehicle: this.state.averageLoadPerFreightVehicle,
                averageAnnualFreightTransportDemand: this.state.averageAnnualFreightTransportDemand,
                humanDrivenVehicles: this.state.humanDrivenVehicles,
                firstGen: this.state.firstGen,
                secondGen: this.state.secondGen,
                fuelCost: this.state.fuelCost,
                electricityCost: this.state.electricityCost,
                fuelConsumption: this.state.fuelConsumption,
                electricityConsumption: this.state.electricityConsumption,
                travelTime: this.state.travelTime,
                vehicleOperationCost: this.state.vehicleOperationCost,
                freightTransportCost: this.state.freightTransportCost,
                accessToTravel: this.state.accessToTravel,
                travelSplitPublicTransport: this.state.travelSplitPublicTransport,
                travelSplitActiveTravel: this.state.travelSplitActiveTravel,
                shareMobilityRate: this.state.shareMobilityRate,
                vehicleUtilisationRate: this.state.vehicleUtilisationRate,
                vehicleOccupancy: this.state.vehicleOccupancy,
                amountOfTravel: this.state.amountOfTravel,
                congestion: this.state.congestion,
                parkingSpace: this.state.parkingSpace,
                nox: this.state.nox,
                co2: this.state.co2,
                pm10: this.state.pm10,
                publicHealth: this.state.publicHealth,
                inequalityInTransport: this.state.inequalityInTransport,
                commutingDistances: this.state.commutingDistances,
                energyEfficiency: this.state.energyEfficiency,
                annualCityPopulation: this.state.annualCityPopulation,
                vruCrashRates: this.state.vruCrashRates,
                roadSafetyMotorized: this.state.roadSafetyMotorized,
                roadSafetyTotalEffect: this.state.roadSafetyTotalEffect
            }
        }).then(resp => {
            this.setState({results: resp.data});
            this.setState({submittedSuccessfully: true});
        }).catch(function (error) {
            switch (error.response.status) {
                case 403:
                    removeUserSession();
                    window.location.href = '/back_casting';
                    break;
                default:
                    self.setState({hasError: true});
                    let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                        error.response.data[0].description : 'Something went wrong. Please try again'
                    self.setState({errorMessage: errorMessage});
                    break;
            }
        });
    }

    onUpdateParamValue(param, event) {
        return this.updateParamValue(param, event.target.value);
    }

    onUpdateImpactValue(param, event) {
        return this.updateImpactValue(param, event.target.value);
    }

    onUpdatePolicyParam(param, event) {
        this.state.policyParams.forEach((p) => {
            if (p.id === param.id) {
                p.value = event.target.value;
            }
        });
        this.setState({policyParams: this.state.policyParams});
    }

    updateParamValue(param, val) {
        if (!param) {
            return;
        }

        switch (param.id) {
            case 1:
                this.onSelectGDP(val);
                break;
            case 2:
                this.onSelectAnnualGDP(val);
                break;
            case 3:
                this.onSelectInflation(val);
                break;
            case 4:
                this.onSelectCityPopulation(val);
                break;
            case 5:
                this.onSelectAnnualCityPopulation(val);
                break;
            case 8:
                this.onSelectAverageLoadPerFreightVehicle(val);
                break;
            case 9:
                this.onSelectAverageAnnualFreightTransportDemand(val);
                break;
            case 10:
                this.onSelectHumanDrivenVehicles(val);
                break;
            case 11:
                this.onSelectFirstGen(val);
                break;
            case 12:
                this.onSelectSecondGen(val);
                break;
            case 13:
                this.onSelectFuelCost(val);
                break;
            case 14:
                this.onSelectElectricityCost(val);
                break;
            case 15:
                this.onSelectFuelConsumption(val);
                break;
            case 16:
                this.onSelectElectricityConsumption(val);
                break;
            case 17:
                this.onSelectVruReferenceSpeed(val);
                break;
            case 18:
                this.onSelectVruAccidentShare(val);
                break;
            default:
                // do nothing
                break
        }
    }

    updateImpactValue(param, val) {
        if (!param) {
            return;
        }

        switch (param.id) {
            case 1:
                this.onSelectTravelTime(val);
                break;
            case 2:
                this.onSelectVehicleOperationCost(val);
                break;
            case 3:
                this.onSelectFreightTransportCost(val);
                break;
            case 4:
                this.onSelectAccessToTravel(val);
                break;
            case 5:
                this.onSelectAmountOfTravel(val);
                break;
            case 6:
                this.onSelectCongestion(val);
                break;
            case 7:
                this.onSelectTravelSplitPublicTransport(val);
                break;
            case 8:
                this.onSelectTravelSplitActiveTravel(val);
                break;
            case 9:
                this.onSelectShareMobilityRate(val);
                break;
            case 10:
                this.onSelectVehicleUtilisationRate(val);
                break;
            case 11:
                this.onSelectVehicleOccupancy(val);
                break;
            case 12:
                this.onSelectParkingSpace(val);
                break;
            case 14:
                this.onSelectEnergyEfficiency(val);
                break;
            case 15:
                this.onSelectNox(val);
                break;
            case 16:
                this.onSelectCo2(val);
                break;
            case 17:
                this.onSelectPm10(val);
                break;
            case 18:
                this.onSelectPublicHealth(val);
                break;
            case 19:
                this.onSelectInequalityInTransport(val);
                break;
            case 20:
                this.onSelectCommutingDistances(val);
                break;
            case 21:
                this.onSelectVruCrashRates(val);
                break;
            case 22:
                this.onSelectSafetyMotorized(val);
                break;
            case 23:
                this.onSelectRoadSafetyTotalEffect(val);
                break;
            default:
                // do nothing
                break
        }
    }

    onSelectGDP(val) {
        this.setState({gdpPerCapita: val});
    }

    onSelectAnnualGDP(val) {
        this.setState({annualGdp: val});
    }

    onSelectInflation(val) {
        this.setState({inflation: val});
    }

    onSelectCityPopulation(val) {
        this.setState({cityPopulation: val});
    }

    onSelectUrbanShuttleFleetSize(val) {
        this.setState({urbanShuttleFleetSize: val});
    }

    onSelectFreightShuttleFleetSize(val) {
        this.setState({freightShuttleFleetSize: val});
    }

    onSelectAverageLoadPerFreightVehicle(val) {
        this.setState({averageLoadPerFreightVehicle: val});
    }

    onSelectAverageAnnualFreightTransportDemand(val) {
        this.setState({averageAnnualFreightTransportDemand: val});
    }

    onSelectAnnualCityPopulation(val) {
        this.setState({annualCityPopulation: val});
    }

    onSelectHumanDrivenVehicles(val) {
        this.setState({humanDrivenVehicles: val});
    }

    onSelectFirstGen(val) {
        this.setState({firstGen: val});
    }

    onSelectSecondGen(val) {
        this.setState({secondGen: val});
    }

    onSelectFuelCost(val) {
        this.setState({fuelCost: val});
    }

    onSelectElectricityCost(val) {
        this.setState({electricityCost: val});
    }

    onSelectTravelTime(val) {
        this.setState({travelTime: val});
    }

    onSelectElectricityConsumption(val) {
        this.setState({electricityConsumption: val});
    }

    onSelectFuelConsumption(val) {
        this.setState({fuelConsumption: val});
    }

    onSelectAmountOfTravel(val) {
        this.setState({amountOfTravel: val});
    }

    onSelectCongestion(val) {
        this.setState({congestion: val});
    }

    onSelectParkingSpace(val) {
        this.setState({parkingSpace: val});
    }

    onSelectEnergyEfficiency(val) {
        this.setState({energyEfficiency: val});
    }

    onSelectNox(val) {
        this.setState({nox: val});
    }

    onSelectCo2(val) {
        this.setState({co2: val});
    }

    onSelectPm10(val) {
        this.setState({pm10: val});
    }

    onSelectVehicleOperationCost(val) {
        this.setState({vehicleOperationCost: val});
    }

    onSelectFreightTransportCost(val) {
        this.setState({freightTransportCost: val});
    }

    onSelectAccessToTravel(val) {
        this.setState({accessToTravel: val});
    }

    onSelectTravelSplitPublicTransport(val) {
        this.setState({travelSplitPublicTransport: val});
    }

    onSelectTravelSplitActiveTravel(val) {
        this.setState({travelSplitActiveTravel: val});
    }

    onSelectShareMobilityRate(val) {
        this.setState({shareMobilityRate: val});
    }

    onSelectVehicleUtilisationRate(val) {
        this.setState({vehicleUtilisationRate: val});
    }

    onSelectVehicleOccupancy(val) {
        this.setState({vehicleOccupancy: val});
    }

    onSelectPublicHealth(val) {
        this.setState({publicHealth: val});
    }

    onSelectInequalityInTransport(val) {
        this.setState({inequalityInTransport: val});
    }

    onSelectCommutingDistances(val) {
        this.setState({commutingDistances: val});
    }

    onSelectVruReferenceSpeed(val) {
        this.setState({vruReferenceSpeed: val});
    }

    onSelectVruAccidentShare(val) {
        this.setState({vruAccidentShare: val});
    }

    onSelectVruCrashRates(val) {
        this.setState({vruCrashRates: val});
    }

    onSelectSafetyMotorized(val) {
        this.setState({roadSafetyMotorized: val});
    }

    onSelectRoadSafetyTotalEffect(val) {
        this.setState({roadSafetyTotalEffect: val});
    }

    onUpdateTargetImpact1(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({targetImpact1: impact});
    }

    onUpdateTargetImpact2(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({targetImpact2: impact});
    }

    onUpdateTargetImpact3(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({targetImpact3: impact});
    }

    onUpdateTargetImpact4(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({targetImpact4: impact});
    }

    onUpdateTargetImpact5(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({targetImpact5: impact});
    }

    onUpdateTargetImpactValue1(event) {
        this.setState({targetImpact1Value: event.target.value});
    }

    onUpdateTargetImpactValue2(event) {
        this.setState({targetImpact2Value: event.target.value});
    }

    onUpdateTargetImpactValue3(event) {
        this.setState({targetImpact3Value: event.target.value});
    }

    onUpdateTargetImpactValue4(event) {
        this.setState({targetImpact4Value: event.target.value});
    }

    onUpdateTargetImpactValue5(event) {
        this.setState({targetImpact5Value: event.target.value});
    }

    onSelectAutomationScenario(event) {
        this.setState({baseScenario: event.target.value});
    }

    onSelectAddImpact(event) {
        if (!this.state.showTargetImpact2) {
            this.setState({showTargetImpact2: true});
        } else if (!this.state.showTargetImpact3) {
            this.setState({showTargetImpact3: true});
        } else if (!this.state.showTargetImpact4) {
            this.setState({showTargetImpact4: true});
        } else if (!this.state.showTargetImpact5) {
            this.setState({showTargetImpact5: true});
        }
    }

    onSelectRemoveImpact(event) {
        if (this.state.showTargetImpact5) {
            this.setState({showTargetImpact5: false});
            this.setState({targetImpact5: null});
            this.setState({targetImpact5Value: null});
        } else if (this.state.showTargetImpact4) {
            this.setState({showTargetImpact4: false});
            this.setState({targetImpact4: null});
            this.setState({targetImpact4Value: null});
        } else if (this.state.showTargetImpact3) {
            this.setState({showTargetImpact3: false});
            this.setState({targetImpact3: null});
            this.setState({targetImpact3Value: null});
        } else if (this.state.showTargetImpact2) {
            this.setState({showTargetImpact2: false});
            this.setState({targetImpact2: null});
            this.setState({targetImpact2Value: null});
        }
    }

    updateTargetImpact(index, value) {
        if (index === 0) {
            this.setState({targetImpact1: value});
        } else if (index === 1) {
            this.setState({targetImpact2: value});
        } else if (index === 2) {
            this.setState({targetImpact3: value});
        } else if (index === 3) {
            this.setState({targetImpact4: value});
        } else if (index === 4) {
            this.setState({targetImpact5: value});
        }
    }

    sendToResult() {
        return <BackCastingResult baseScenario={this.state.baseScenario} targetYear = {this.state.targetYear} data={this.state.results}/>
    }

    retrieveParam(id) {
        if (this.state.params.length > 0) {
            let obj = this.state.params.find(p => p.id === id);
            return obj.defaultValue;
        }
        return 0;
    }

    renderError() {
        if (this.state.hasError) {
            return <CustomAlert variant={'danger'} message={this.state.errorMessage}/>;
        }
    };

    retrieveImpactDefaultValue(id) {
        return this.state.impacts.find(p => p.id === id);
    }

    searchPage() {
        return <Container>
            <Form noValidate
                  validated={this.state.validated}
                  onSubmit={this.onSubmit}
                  className="mt-4 mb-5">

                <div className="mb-5">
                    <h2 className="text-center">Backcasting module</h2>
                </div>

                {this.renderTargetImpacts()}

                {this.renderParams()}

                {this.renderImpacts()}

                {this.renderButtons()}

                <Row>
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        {this.renderError()}
                    </Col>
                </Row>
            </Form>
        </Container>
    }

    renderParams() {
        return (
            <div>
                <Row className="section-header">
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        <h5>Parameters</h5>
                        <p className="text-center font-italic">Please enter input parameters</p>
                    </Col>
                </Row>
                <Row>
                    {this.state.params.filter(param => param.id !== 10 && param.id !== 11 && param.id !== 12).map((param) => (
                        <Col key={param.id} xs={12} md={3}>
                            <Form.Group md="12" controlId={param.id}>
                                <Form.Label>{param.description} [{param.measurementUnit}]</Form.Label>
                                <Form.Control type="number" step="any" min="0" lang="en_US"
                                              defaultValue={param.defaultValue}
                                              placeholder={param.defaultValue}
                                              onChange={(e) => this.onUpdateParamValue(param, e)}/>
                                <Form.Text id={param.id} muted>
                                    {param.explanation}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            </div>
        )
    }


    renderImpacts() {
        return (
            <div>
                <Row className="section-header">
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        <h5>Impacts</h5>
                        <p className="text-center font-italic">Please provide initial values based on your city or test network</p>
                    </Col>
                </Row>

                <Row>
                    {this.state.impacts.map((impact) => (
                        <Col key={impact.id} xs={12} md={3}>
                            <Form.Group md="12" controlId={impact.id}>
                                <Form.Label>{impact.impact}</Form.Label>
                                <Form.Control type="number" step="any" min="0" lang="en_US"
                                              aria-describedby={impact.id}
                                              defaultValue={impact.defaultValue}
                                              placeholder={impact.defaultValue}
                                              onChange={(e) => this.onUpdateImpactValue(impact, e)}/>
                                <Form.Text id={impact.id} muted>
                                    {impact.description}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            </div>
        )
    }

    renderTargetImpacts() {
        return (
            <div>
                <Row className="section-header">
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        <h5>Target Parameters</h5>
                    </Col>
                </Row>


                <Row>
                    <Col xs={12} md={3}>
                        <Form.Group controlId="targetYear">
                            <Form.Label>Target Year</Form.Label>
                            <Form.Control type="number" min="2020"
                                          max="2050"
                                          required
                                          aria-describedby="targetYear"
                                          onChange={this.onSelectTargetYear.bind(this)}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="baseScenario">
                            <Form.Label>Base Scenario (CCAM deployment)</Form.Label>
                            <Form.Control
                                as="select"
                                required
                                onChange={this.onSelectAutomationScenario.bind(this)}>
                                <option value="">-- Please Select --</option>
                                <option value="SCENARIO_1_NO_AUTOMATION">SCENARIO 1 - NO AUTOMATION</option>
                                <option value="SCENARIO_2_PESSIMISTIC">SCENARIO 2 - PESSIMISTIC</option>
                                <option value="SCENARIO_3_NEUTRAL">SCENARIO 3 - NEUTRAL</option>
                                <option value="SCENARIO_4_OPTIMISTIC">SCENARIO 4 - OPTIMISTIC</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>


                <Row>
                    <Col key={'targetImpactKey1'} xs={12} md={3}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Target Impact 1</Form.Label>
                            <Form.Control
                                as="select"
                                required
                                onChange={(e) => this.onUpdateTargetImpact1(e)}>
                                <option value="">{'-- Please Select --'}</option>
                                {this.state.impacts.map((impact) => (
                                    <option
                                        disabled={impact.id === this.state.targetImpact2 || impact.id === this.state.targetImpact3 ||
                                            impact.id === this.state.targetImpact4 || impact.id === this.state.targetImpact5}
                                        value={impact.id}>{impact.impact}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col key={'targetImpactValue1'} xs={12} md={4}>
                        <Form.Group controlId={1}>
                            <Form.Label>&nbsp;</Form.Label>
                            <Form.Control type="number" step="any" min="0" lang="en_US"
                                          aria-describedby={1}
                                          required
                                          disabled={!this.state.targetImpact1}
                                          onChange={(e) => this.onUpdateTargetImpactValue1(e)}/>
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                {this.renderTargetImpact2()}
                {this.renderTargetImpact3()}
                {this.renderTargetImpact4()}
                {this.renderTargetImpact5()}

                {this.renderToggleButtons()}

            </div>
        )
    }

    renderTargetImpact2() {
        if (this.state.showTargetImpact2) {
            return (
                <Row>
                    <Col key={'targetImpactKey2'} xs={12} md={3}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Target Impact 2</Form.Label>
                            <Form.Control
                                as="select"
                                required
                                onChange={(e) => this.onUpdateTargetImpact2(e)}>
                                <option value="">{'-- Please Select --'}</option>
                                {this.state.impacts.map((impact) => (
                                    <option
                                        disabled={impact.id === this.state.targetImpact1 || impact.id === this.state.targetImpact3 ||
                                            impact.id === this.state.targetImpact4 || impact.id === this.state.targetImpact5}
                                        value={impact.id}>{impact.impact}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col key={'targetImpactValue2'} xs={12} md={4}>
                        <Form.Group controlId={2}>
                            <Form.Label>&nbsp;</Form.Label>
                            <Form.Control type="number" step="any" min="0" lang="en_US"
                                          required
                                          disabled={!this.state.targetImpact2}
                                          onChange={(e) => this.onUpdateTargetImpactValue2(e)}/>
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
            )
        }
    }

    renderTargetImpact3() {
        if (this.state.showTargetImpact3) {
            return (<Row>
                <Col key={'targetImpactKey3'} xs={12} md={3}>
                    <Form.Group controlId="useCase">
                        <Form.Label>Target Impact 3</Form.Label>
                        <Form.Control
                            as="select"
                            required
                            onChange={(e) => this.onUpdateTargetImpact3(e)}>
                            <option value="">{'-- Please Select --'}</option>
                            {this.state.impacts.map((impact) => (
                                <option
                                    disabled={impact.id === this.state.targetImpact2 || impact.id === this.state.targetImpact1 ||
                                        impact.id === this.state.targetImpact4 || impact.id === this.state.targetImpact5}
                                    value={impact.id}>{impact.impact}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col key={'targetImpactValue1'} xs={12} md={4}>
                    <Form.Group controlId={3}>
                        <Form.Label>&nbsp;</Form.Label>
                        <Form.Control type="number" step="any" min="0" lang="en_US"
                                      required
                                      disabled={!this.state.targetImpact3}
                                      onChange={(e) => this.onUpdateTargetImpactValue3(e)}/>
                        <Form.Control.Feedback type="invalid">
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>)
        }
    }

    renderTargetImpact4() {
        if (this.state.showTargetImpact4) {
            return (
                <Row>
                    <Col key={'targetImpactKey4'} xs={12} md={3}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Target Impact 4</Form.Label>
                            <Form.Control
                                as="select"
                                required
                                onChange={(e) => this.onUpdateTargetImpact4(e)}>
                                <option value="">{'-- Please Select --'}</option>
                                {this.state.impacts.map((impact) => (
                                    <option
                                        disabled={impact.id === this.state.targetImpact2 || impact.id === this.state.targetImpact3 ||
                                            impact.id === this.state.targetImpact1 || impact.id === this.state.targetImpact5}
                                        value={impact.id}>{impact.impact}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col key={'targetImpactValue3'} xs={12} md={4}>
                        <Form.Group controlId={4}>
                            <Form.Label>&nbsp;</Form.Label>
                            <Form.Control type="number" step="any" min="0" lang="en_US"
                                          aria-describedby={1}
                                          required
                                          disabled={!this.state.targetImpact4}
                                          onChange={(e) => this.onUpdateTargetImpactValue4(e)}/>
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
            )
        }
    }

    renderTargetImpact5() {
        if (this.state.showTargetImpact5) {
            return (
                <Row>
                    <Col key={'targetImpactKey5'} xs={12} md={3}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Target Impact 5</Form.Label>
                            <Form.Control
                                as="select"
                                required
                                onChange={(e) => this.onUpdateTargetImpact5(e)}>
                                <option value="">{'-- Please Select --'}</option>
                                {this.state.impacts.map((impact) => (
                                    <option
                                        disabled={impact.id === this.state.targetImpact2 || impact.id === this.state.targetImpact3 ||
                                            impact.id === this.state.targetImpact4 || impact.id === this.state.targetImpact1}
                                        value={impact.id}>{impact.impact}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col key={'targetImpactValue5'} xs={12} md={4}>
                        <Form.Group controlId={5}>
                            <Form.Label>&nbsp;</Form.Label>
                            <Form.Control type="number" step="any" min="0" lang="en_US"
                                          aria-describedby={1}
                                          required
                                          disabled={!this.state.targetImpact5}
                                          onChange={(e) => this.onUpdateTargetImpactValue5(e)}/>
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>)
        }
    }

    renderToggleButtons() {
        return (<Row className="mt-4 mb-4">
            <Col xs={12} md={3}>
                <Button onClick={this.onSelectAddImpact.bind(this)}
                        disabled={this.state.showTargetImpact5}
                        variant="outline-primary">{'Add'}</Button>
                {this.renderRemoveImpactButton()}
            </Col>

        </Row>)

    }

    renderRemoveImpactButton() {
        if (this.state.showTargetImpact2) {
            return (
                <Button className='ml-4' onClick={this.onSelectRemoveImpact.bind(this)}
                        variant="outline-primary">{'Remove'}</Button>
            )
        }
    }

    renderButtons() {
        const display = true;

        return (<Row>
            <Col xs={12} md={{span: 6, offset: 3}}>
                <Button disabled={!display} block type="submit">Submit</Button>
            </Col>
        </Row>)
    }

    render() {

        const submittedSuccessfully = this.state.submittedSuccessfully;
        let component;
        if (submittedSuccessfully) {
            component = this.sendToResult();
        } else {
            component = this.searchPage();
        }

        return (
            <div>
                {component}
            </div>
        )
    }


}

export default BackCasting;
